<script lang="ts" module>
  import type { Instruction, SubEvaluation } from '@/teoCore/TeoApi';
  import BaseCard from '@/ui/elements/card/BaseCard.svelte';
  import CardHeader from '@/ui/elements/card/CardHeader.svelte';
  import InfoCard from '@/ui/elements/card/InfoCard.svelte';

  import ToDoPill from './cmps/ToDoPill.svelte';

  export interface InstructionExtended extends Instruction {
    sub_evaluation?: SubEvaluation;
    color?: 'success' | 'warning' | 'error' | 'info';
  }
  export interface InstructionCardProps {
    cardLabel: string;
    instruction: InstructionExtended | undefined;
  }
</script>

<script lang="ts">
  let { instruction, cardLabel }: InstructionCardProps = $props();
</script>

{#if !instruction}
  <p>No instructions available</p>
{:else}
  <BaseCard>
    {#snippet header()}
      <CardHeader {cardLabel}>
        <ToDoPill
          title={instruction.sub_evaluation?.title ?? instruction.short_title}
          score={instruction.sub_evaluation?.score ?? 0}
          color={instruction.color}
        ></ToDoPill>
      </CardHeader>
    {/snippet}
    <InfoCard shortText={instruction.title} longText={instruction.description}></InfoCard>
  </BaseCard>
{/if}
